import { Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import Molten from '@leverege/molten';
const sleep = ms => new Promise(r => {
  setTimeout(r, ms);
});
function getApi(ids, api) {
  const {
    systemId,
    companyId,
    locationId,
    deviceId,
    orgId
  } = ids;
  let nApi;
  if (locationId) {
    if (orgId && companyId) {
      nApi = api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId);
    } else if (companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId);
    } else {
      nApi = api.interface(systemId, 'location').obj(locationId);
    }
    nApi = nApi.grp('tags').obj(deviceId);
  } else if (companyId) {
    if (orgId) {
      nApi = api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId);
    } else {
      nApi = api.interface(systemId, 'company').obj(companyId);
    }
    nApi = nApi.grp('tags').obj(deviceId);
  } else if (orgId) {
    nApi = api.interface(systemId, 'organization').obj(orgId).grp('tags').obj(deviceId);
  } else {
    nApi = api.system(systemId);
  }
  return nApi;
}
export function searchRelationship({
  companyId,
  locationId,
  relationship
}, opts) {
  const systemId = Molten.getConfig('api/systemId');
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let action;
    if (locationId && companyId) {
      action = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp(relationship);
    } else if (locationId) {
      action = api.interface(systemId, 'location').obj(locationId).grp(relationship);
    } else if (companyId) {
      action = api.interface(systemId, 'company').obj(companyId).grp(relationship);
    } else {
      action = api.interface(systemId, 'tag');
    }
    return action.search(opts);
  });
}
export function resetGateway(systemId, gatewayId) {
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return api.system(systemId).srv('kudelskidevice').post(`device/${gatewayId}/command`, {
      command: {
        type: 'reset.request'
      }
    }, {}).catch(() => {
      Toast.error('Error resetting gateway');
    });
  });
}
export function cancelGatewayReset(systemId, gatewayId) {
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return api.system(systemId).srv('kudelskidevice').post(`device/${gatewayId}/command`, {
      command: {
        type: 'reset.cancel'
      }
    }, {}).catch(() => {
      Toast.error('Error cancelling gateway reset');
    });
  });
}
export async function ringTag(ids, reloadData) {
  const {
    deviceId
  } = ids;
  await GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return getApi(ids, api).srv('kudelskidevice').post(`device/${deviceId}/command`, {
      command: {
        type: 'peripheralDevice.request.ring'
      }
    }, {}).catch(() => {
      Toast.error('Error ringing tag');
    });
  });
  await sleep(3000);
  reloadData?.();
}
export async function cancelRingTag(ids, reloadData) {
  const {
    deviceId
  } = ids;
  await GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return getApi(ids, api).srv('kudelskidevice').post(`device/${deviceId}/command`, {
      command: {
        type: 'peripheralDevice.cancel.ring'
      }
    }, {}).catch(() => {
      Toast.error('Error cancelling tag ring');
    });
  });
  await sleep(3000);
  reloadData?.();
}
export async function pairTagToKey({
  keyId,
  tagId,
  companyId,
  locationId,
  force
}) {
  const systemId = Molten.getConfig('api/systemId');
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let nApi;
    if (locationId && companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('keys');
    } else if (locationId) {
      nApi = api.interface(systemId, 'location').obj(locationId).grp('keys');
    } else if (companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('keys');
    } else {
      nApi = api.interface(systemId, 'key');
    }
    return nApi.obj(keyId).grp('tag').create({
      id: tagId,
      force
    });
  });
}
export async function unpairTagFromKey({
  keyId,
  companyId,
  locationId
}) {
  const systemId = Molten.getConfig('api/systemId');
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let nApi;
    if (locationId && companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('keys');
    } else if (locationId) {
      nApi = api.interface(systemId, 'location').obj(locationId).grp('keys');
    } else if (companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('keys');
    } else {
      nApi = api.interface(systemId, 'key');
    }
    return nApi.obj(keyId).obj('tag').delete();
  });
}